export default __webpack_public_path__ + "static/pandt-thumb-9dd8f24ffffd7df379f07f7d6497bff2-9dd8f24ffffd7df379f07f7d6497bff2.jpeg";